import { Reasoning } from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

export function ReasoningDemo() {
  return (
    <Section
      id="reasoning"
      title="Reasoning"
      description="Collapsible chain-of-thought disclosure. Renderer for the K2 `reasoning` block - props are `{ title?, steps?: [{label, detail?}], text?, defaultOpen? }`."
    >
      <VariantBlock label="Discrete steps (open)">
        <div className="w-full max-w-xl">
          <Reasoning
            title="How I got here"
            defaultOpen
            steps={[
              { label: "Parsed the request", detail: "Identified the user wants a **weekly** summary." },
              { label: "Pulled the data", detail: "Queried the last 7 days of events." },
              { label: "Ranked by impact", detail: "Sorted by reach, then recency." },
            ]}
          />
        </div>
      </VariantBlock>

      <VariantBlock label="Free-form text (collapsed by default)">
        <div className="w-full max-w-xl">
          <Reasoning text={"Let me think about this step by step.\n\nFirst, the constraint is the deadline. Second, the locked toolset narrows the options. So the plan is to ship the smallest correct slice first."} />
        </div>
      </VariantBlock>
    </Section>
  );
}
